function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { nanoid } from 'nanoid/non-secure';
import { Provider, RequestClient, Socket } from '@uppy/companion-client';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import EventTracker from '@uppy/utils/lib/EventTracker';
import ProgressTimeout from '@uppy/utils/lib/ProgressTimeout';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
import { internalRateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue'; // See XHRUpload

function buildResponseError(xhr, error) {
  if (isNetworkError(xhr)) return new NetworkError(error, xhr);
  var err = new ErrorWithCause('Upload error', {
    cause: error
  });
  err.request = xhr;
  return err;
} // See XHRUpload


function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

function addMetadata(formData, meta, opts) {
  var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
  : Object.keys(meta);
  allowedMetaFields.forEach(function (item) {
    formData.append(item, meta[item]);
  });
}

function createFormDataUpload(file, opts) {
  var formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  var dataWithUpdatedType = setTypeInBlob(file);

  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }

  return formPost;
}

var createBareUpload = function createBareUpload(file) {
  return file.data;
};

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _getOptions = /*#__PURE__*/_classPrivateFieldLooseKey("getOptions");

var _addEventHandlerForFile = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerForFile");

var _addEventHandlerIfFileStillExists = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerIfFileStillExists");

var _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var _uploadRemoteFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadRemoteFile");

var MiniXHRUpload = /*#__PURE__*/function () {
  function MiniXHRUpload(_uppy, _opts) {
    var _this2 = this;

    _classCallCheck(this, MiniXHRUpload);

    Object.defineProperty(this, _uploadRemoteFile, {
      value: _uploadRemoteFile2
    });
    Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    Object.defineProperty(this, _getOptions, {
      value: _getOptions2
    });
    Object.defineProperty(this, _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
          var opts, Client, client, allowedMetaFields, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  opts = _classPrivateFieldLooseBase(_this2, _getOptions)[_getOptions](file);
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this2.uppy, file.remote.providerOptions);
                  allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
                  : Object.keys(file.meta);

                  if (file.tus) {
                    // Install file-specific upload overrides.
                    Object.assign(opts, file.tus);
                  }

                  _context.next = 7;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    protocol: 'multipart',
                    endpoint: opts.endpoint,
                    size: file.data.size,
                    fieldname: opts.fieldName,
                    metadata: Object.fromEntries(allowedMetaFields.map(function (name) {
                      return [name, file.meta[name]];
                    })),
                    httpMethod: opts.method,
                    useFormData: opts.formData,
                    headers: opts.headers
                  }));

                case 7:
                  res = _context.sent;
                  return _context.abrupt("return", res.token);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    this.uppy = _uppy;
    this.opts = _objectSpread({
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    }, _opts);
    this.requests = _opts[internalRateLimitedQueue];
    this.uploaderEvents = Object.create(null);
    this.i18n = _opts.i18n;
    _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken] = this.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(this, _requestSocketToken)[_requestSocketToken], {
      priority: -1
    });
  }

  _createClass(MiniXHRUpload, [{
    key: "uploadFile",
    value: function uploadFile(id, current, total) {
      var file = this.uppy.getFile(id);

      if (file.error) {
        throw new Error(file.error);
      } else if (file.isRemote) {
        return _classPrivateFieldLooseBase(this, _uploadRemoteFile)[_uploadRemoteFile](file, current, total);
      }

      return _classPrivateFieldLooseBase(this, _uploadLocalFile)[_uploadLocalFile](file, current, total);
    }
  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var opts = _classPrivateFieldLooseBase(_this3, _getOptions)[_getOptions](file);

        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket;

        var createSocket = function createSocket() {
          if (socket != null) return;
          socket = new Socket({
            target: "".concat(host, "/api/").concat(token)
          });
          socket.on('progress', function (progressData) {
            return emitSocketProgress(_this3, progressData, file);
          });
          socket.on('success', function (data) {
            var body = opts.getResponseData(data.response.responseText, data.response);
            var uploadURL = body[opts.responseUrlFieldName];
            var uploadResp = {
              status: data.response.status,
              body: body,
              uploadURL: uploadURL,
              bytesUploaded: data.bytesUploaded
            };

            _this3.uppy.emit('upload-success', file, uploadResp);

            queuedRequest.done(); // eslint-disable-line no-use-before-define

            socket.close();

            if (_this3.uploaderEvents[file.id]) {
              _this3.uploaderEvents[file.id].remove();

              _this3.uploaderEvents[file.id] = null;
            }

            return resolve();
          });
          socket.on('error', function (errData) {
            var resp = errData.response;
            var error = resp ? opts.getResponseError(resp.responseText, resp) : new ErrorWithCause(errData.error.message, {
              cause: errData.error
            });

            _this3.uppy.emit('upload-error', file, error);

            queuedRequest.done(); // eslint-disable-line no-use-before-define

            if (_this3.uploaderEvents[file.id]) {
              _this3.uploaderEvents[file.id].remove();

              _this3.uploaderEvents[file.id] = null;
            }

            reject(error);
          });
        };

        _this3.uploaderEvents[file.id] = new EventTracker(_this3.uppy);

        var queuedRequest = _this3.requests.run(function () {
          if (file.isPaused) {
            var _socket;

            (_socket = socket) == null ? void 0 : _socket.send('pause', {});
          } else {
            createSocket();
          }

          return function () {
            return socket.close();
          };
        });

        _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
          var _socket2;

          (_socket2 = socket) == null ? void 0 : _socket2.send('cancel', {});
          queuedRequest.abort();
          resolve("upload ".concat(file.id, " was removed"));
        });

        _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function (_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
              reason = _ref.reason;

          if (reason === 'user') {
            var _socket3;

            (_socket3 = socket) == null ? void 0 : _socket3.send('cancel', {});
            queuedRequest.abort();
          }

          resolve("upload ".concat(file.id, " was canceled"));
        });

        var onRetryRequest = function onRetryRequest() {
          if (socket == null) {
            queuedRequest.abort();
          } else {
            socket.send('pause', {});
            queuedRequest.done();
          }

          queuedRequest = _this3.requests.run(function () {
            if (!file.isPaused) {
              if (socket == null) {
                createSocket();
              } else {
                socket.send('resume', {});
              }
            }

            return function () {
              return socket.close();
            };
          });
        };

        _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('upload-retry', file.id, onRetryRequest);

        _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('retry-all', file.id, onRetryRequest);
      }).catch(function (err) {
        _this3.uppy.emit('upload-error', file, err);

        return Promise.reject(err);
      });
    }
  }]);

  return MiniXHRUpload;
}();

export { MiniXHRUpload as default };

function _getOptions2(file) {
  var _file$xhrUpload;

  var uppy = this.uppy;
  var overrides = uppy.getState().xhrUpload;

  var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
    headers: _objectSpread(_objectSpread(_objectSpread({}, this.opts.headers), overrides == null ? void 0 : overrides.headers), (_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers)
  });

  return opts;
}

function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, function (fileOrID) {
    var _fileOrID$id; // TODO (major): refactor Uppy events to consistently send file objects (or consistently IDs)
    // We created a generic `addEventListenerForFile` but not all events
    // use file IDs, some use files, so we need to do this weird check.


    var id = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id) eventHandler();
  });
}

function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;

  this.uploaderEvents[fileID].on(eventName, function () {
    if (_this.uppy.getFile(fileID)) eventHandler.apply(void 0, arguments);
  });
}

function _uploadLocalFile2(file, current, total) {
  var _this4 = this;

  var opts = _classPrivateFieldLooseBase(this, _getOptions)[_getOptions](file);

  this.uppy.log("uploading ".concat(current, " of ").concat(total));
  return new Promise(function (resolve, reject) {
    // This is done in index.js in the S3 plugin.
    // this.uppy.emit('upload-started', file)
    var data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
    var xhr = new XMLHttpRequest();
    _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);
    var timer = new ProgressTimeout(opts.timeout, function () {
      xhr.abort(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();
      var error = new Error(_this4.i18n('timedOut', {
        seconds: Math.ceil(opts.timeout / 1000)
      }));

      _this4.uppy.emit('upload-error', file, error);

      reject(error);
    });
    var id = nanoid();
    xhr.upload.addEventListener('loadstart', function () {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " started"));
    });
    xhr.upload.addEventListener('progress', function (ev) {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total)); // Begin checking for timeouts when progress starts, instead of loading,
      // to avoid timing out requests on browser concurrency queue


      timer.progress();

      if (ev.lengthComputable) {
        _this4.uppy.emit('upload-progress', file, {
          uploader: _this4,
          bytesUploaded: ev.loaded,
          bytesTotal: ev.total
        });
      }
    });
    xhr.addEventListener('load', function (ev) {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " finished"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this4.uploaderEvents[file.id]) {
        _this4.uploaderEvents[file.id].remove();

        _this4.uploaderEvents[file.id] = null;
      }

      if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
        var _body = opts.getResponseData(xhr.responseText, xhr);

        var uploadURL = _body[opts.responseUrlFieldName];
        var uploadResp = {
          status: ev.target.status,
          body: _body,
          uploadURL: uploadURL
        };

        _this4.uppy.emit('upload-success', file, uploadResp);

        if (uploadURL) {
          _this4.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
        }

        return resolve(file);
      }

      var body = opts.getResponseData(xhr.responseText, xhr);
      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
      var response = {
        status: ev.target.status,
        body: body
      };

      _this4.uppy.emit('upload-error', file, error, response);

      return reject(error);
    });
    xhr.addEventListener('error', function () {
      _this4.uppy.log("[AwsS3/XHRUpload] ".concat(id, " errored"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this4.uploaderEvents[file.id]) {
        _this4.uploaderEvents[file.id].remove();

        _this4.uploaderEvents[file.id] = null;
      }

      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));

      _this4.uppy.emit('upload-error', file, error);

      return reject(error);
    });
    xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
    // before `open()` is called. It’s important to set withCredentials
    // to a boolean, otherwise React Native crashes

    xhr.withCredentials = Boolean(opts.withCredentials);

    if (opts.responseType !== '') {
      xhr.responseType = opts.responseType;
    }

    Object.keys(opts.headers).forEach(function (header) {
      xhr.setRequestHeader(header, opts.headers[header]);
    });

    var queuedRequest = _this4.requests.run(function () {
      xhr.send(data);
      return function () {
        // eslint-disable-next-line no-use-before-define
        timer.done();
        xhr.abort();
      };
    }, {
      priority: 1
    });

    _classPrivateFieldLooseBase(_this4, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
      queuedRequest.abort();
      reject(new Error('File removed'));
    });

    _classPrivateFieldLooseBase(_this4, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          reason = _ref2.reason;

      if (reason === 'user') {
        queuedRequest.abort();
      }

      reject(new Error('Upload cancelled'));
    });
  });
}

function _uploadRemoteFile2(_x2) {
  return _uploadRemoteFile3.apply(this, arguments);
}

function _uploadRemoteFile3() {
  _uploadRemoteFile3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
    var serverToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (!file.serverToken) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", this.connectToServerSocket(file));

          case 3:
            _context2.next = 5;
            return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);

          case 5:
            serverToken = _context2.sent;

            if (this.uppy.getState().files[file.id]) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 8:
            this.uppy.setFileState(file.id, {
              serverToken: serverToken
            });
            return _context2.abrupt("return", this.connectToServerSocket(this.uppy.getFile(file.id)));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            this.uppy.emit('upload-error', file, _context2.t0);
            throw _context2.t0;

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 12]]);
  }));
  return _uploadRemoteFile3.apply(this, arguments);
}